// src/components/brands/BrandTable.js
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { useCarContext } from '../components/Context/CarContext';
import ConfirmDialog from '../views/ConfirmDialog';
import EditDialogBrand from './EditDialog/EditDialogBrand';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';

const BrandTable = ({deleteBrand}) => {
  const { DeleteBrand,UpdateBrand, brands,editBrand,editOpen,setEditOpen,editType,currentEditData,carbrands, } = useCarContext();
  const [open, setOpen] = useState(false);
  const [selectedBrandId, setSelectedBrandId] = useState(null); // Store the ID of the brand to delete
  const handleDeleteClick = (id) => {
    setSelectedBrandId(id); // Set the brand ID to delete
    setOpen(true); // Open the confirmation dialog
  };
  const handleClose = () => {
    setOpen(false); // Close the confirmation dialog
    setSelectedBrandId(null); // Clear the selected brand ID
  };

  const handleConfirm = () => {
    if (selectedBrandId) {
      DeleteBrand(selectedBrandId); // Delete the selected brand
    }
    setOpen(false); // Close the confirmation dialog
    };
    // Handle Save from Edit Dialog
    const handleSaveEditBrand = (updatedData) => {
        if (editType === 'brand') {
            /* setUpdated(updatedData)*/
            UpdateBrand(updatedData)

            // If the edited brand is selected in the filter, no action needed since brand IDs remain the same
        } 
        
    };
    const columns = [
      {
          field: 'link',
          headerName: 'Link',
          width: 50,
          renderCell: (params) => (

              <i className="bi bi-info-circle"></i>
          ),
      },

      { 
        field: 'name', 
        headerName: 'Brand Name',
       width: 150 
      },

      {
        field: 'icon',
        headerName: 'Icon',
        width: 150,
        renderCell: (params) => (
          <div>
             <img src={params.row.icon} alt={params.row.name} width="50" height="50"/>
          </div>
        ),
      },
      {
        field: 'Action',
        headerName: 'Action',
        width: 150,
        renderCell: (params) => (
        <div>
            <IconButton color="primary" onClick={() => editBrand(params.row)}>
              <Edit />
              </IconButton>
            <IconButton color="secondary"  onClick={() => handleDeleteClick(params.row.id)}>
              <Delete />
            </IconButton>
        </div>
        ),
      }
   ];
    
  console.log(brands,"kashi")
  const CustomToolbar = (props) => (
    <GridToolbarContainer>
       
        <GridToolbar />
    </GridToolbarContainer>
);
function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;
}
return (
    <section className="section">
          <div className="row">
            <div className="col-lg-12">
                  <div className="card">
                      <div className="card-body">
                        <h5 className="card-title"></h5>
                          {/* Tabs */}
                          <Box sx={{ width: '100%' }}>
                              <AppBar position="static" color="default">
                                  {/* AppBar content can go here */}
                              </AppBar>
                          </Box>
                          <div style={{ height: '100%', width: '100%' }}>
                              <DataGrid
                               rows={brands}
                               columns={columns}
                               slots={{ toolbar: CustomToolbar }}
                               components={{ Toolbar: GridToolbar }}
                            />
                              <ConfirmDialog
                               open={open}
                               onClose={handleClose}
                               onConfirm={handleConfirm}
                               title="Confirm Deletion"
                               content="Are you sure you want to delete this brand?"
                            />
                        {/* EditDialogBrand for Editing */}
                            <EditDialogBrand
                              open={editOpen}
                              handleClose={() => setEditOpen(false)}
                              type={editType}
                              currentData={currentEditData}
                              brands={carbrands}
                              handleSave={handleSaveEditBrand}
                            />
                          </div>
                      </div>
                  </div>
              </div></div>
    </section>
);
//   return (
//     <TableContainer component={Paper}>
//     <Table aria-label="brands table">
//       <TableHead>
//         <TableRow>
//           <TableCell><strong>Brand Name</strong></TableCell>
//           <TableCell align="right"><strong>Actions</strong></TableCell>
//         </TableRow>
//       </TableHead>
//       <TableBody>
//         {brands.length === 0 && (
//           <TableRow>
//             <TableCell colSpan={2} align="center">
//               <Typography variant="body1">No brands available.</Typography>
//             </TableCell>
//           </TableRow>
//         )}
//         {brands.map((brand) => (
//           <TableRow key={brand.id}>
//                 <TableCell>{brand.name}</TableCell>
//                 <TableCell> <img src={brand.icon} alt={brand.name} width="100" height="100" /></TableCell>
//             <TableCell align="right">
//               <IconButton
//                 color="primary"
//                 onClick={() => editBrand(brand)}
//               >
//                 <Edit />
//               </IconButton>
//               <IconButton
//                 color="secondary"
//                 onClick={() => handleDeleteClick(brand.id)} // Trigger delete confirmation for this brand
//               >
//                 <Delete />
//               </IconButton>
//             </TableCell>
//           </TableRow>
//         ))}
//       </TableBody>
//     </Table>

    
//     <ConfirmDialog
//       open={open}
//       onClose={handleClose}
//       onConfirm={handleConfirm}
//       title="Confirm Deletion"
//       content="Are you sure you want to delete this brand?"
//           />
//           <EditDialogBrand
//               open={editOpen}
//               handleClose={() => setEditOpen(false)}
//               type={editType}
//               currentData={currentEditData}
//               brands={carbrands}
//               handleSave={handleSaveEditBrand}
//           />
//   </TableContainer>
// );

};

export default BrandTable;
